jQuery(document).ready(function ($) {
  $('.ctn-article-card-slider').slick({
    prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><i data-feather="chevron-left"></i></button>',
    nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><i data-feather="chevron-right"></i></button>',
    arrows: true,
    dots: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          centerMode: true
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true
        }
      }
      
    ]
  });

  $('.ctn-article-card-slider').on('breakpoint', function(event, slick, breakpoint) {
    feather.replace();
  });


});